import { IValidationError } from './interfaces/ValidationError';

interface IParams {
  value: string,
  fieldName: string,
  fieldCaption: string,
}

export const validateAlphanumeric = (params: IParams): IValidationError => {
  if (params.value && !/^[a-z0-9_-]+$/i.test(params.value)) {
    return { [params.fieldName]: `${ params.fieldCaption || 'Field' } must be alphanumeric` };
  }
  return null;
};
